module.exports = __webpack_public_path__ + "img/floridaplaza_background_hero.55f66089.png";